"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var query_1 = require("../../query/query");
var FieldArgs_1 = require("./FieldArgs");
var Field = function (args) {
    var _a = FieldArgs_1.default.parseArgs(args), aliasFor = _a.aliasFor, directive = _a.directive, entity = _a.entity, includeIf = _a.includeIf, params = _a.params, query = _a.query;
    return function (cls, property) {
        query_1.setupQuery(cls);
        cls[query_1.QUERY].fields.push({
            aliasFor: aliasFor,
            name: property,
            directive: directive,
            entity: entity,
            includeIf: includeIf,
            params: params,
            query: query
        });
    };
};
exports.default = Field;
//# sourceMappingURL=Field.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/typegraph/dist/decorators/field/Field.js
// module id = 191
// module chunks = 0